<template>
  <div id="app">
    <transition :name="transitionName">
      <router-view @playOrPauseBgMusic="playOrPause" />
    </transition>
    <audio ref="music" src="https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/bg-U38a8wRN.mp3" loop></audio>
  </div>
</template>

<script>
  import actions from '@/store/action-types'
  import mutations from '@/store/mutation-types'

  let routerHistory = ['/']
  if (sessionStorage.getItem('routerHistory')) {
    routerHistory = JSON.parse(sessionStorage.getItem('routerHistory'))
  }

  export default {
    name: 'app',
    data () {
      return {
        musicStatus: -1,
        transitionName: 'page-up'
      }
    },
    computed: {
      urlParams () {
        return this.$store.state.urlParams
      }
    },
    created () {
      // 获取用户数据
      if (this.urlParams.shareId) {
        this.$store.dispatch(actions.get.SHARED_CONTENTS)
      } else {
        this.$store.dispatch(actions.get.USER_DATA)
      }
    },
    methods: {
      playOrPause () {
        const $bgMusic = this.$refs.music
        this.$store.commit(mutations.update.MUSIC_PLAYING_STATUS)
        if ($bgMusic.paused) {
          $bgMusic.play()
          if (this.musicStatus === 0) {
            this.$track.sendActionTrack('landing', 'click_music_on')
          }
          this.musicStatus = 1
        } else {
          $bgMusic.pause()
          if (this.musicStatus === 1) {
            this.$track.sendActionTrack('landing', 'click_music_off')
          }
          this.musicStatus = 0
        }
      }
    },
    // watch $route 决定使用哪种过渡
    watch: {
      '$route' (to, from) {
        if (to.path === routerHistory[routerHistory.length - 2]) {
          routerHistory.pop()
          this.transitionName = 'page-down'
        } else {
          routerHistory.push(to.path)
          this.transitionName = 'page-up'
        }
        sessionStorage.setItem('routerHistory', JSON.stringify(routerHistory))
      }
    }
  }
</script>

<style lang="scss">
  @import './scss/common';

  $bgImage: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/bg-RtUu9yJe.jpg';
  $music: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/music-YKfBEsAX.png';
  $musicPaused: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/pause-s0KyWWZg.png';

  body,
  html {
    height: 100%;
  }
  #app {
    @include bg-image-cover($bgImage);
    position: relative;
    height: 100%;
    > .page {
      width: 750px;
      height: 100%;
      margin-left: auto;
      margin-right: auto;
    }
    .music {
      @include bg-image-cover($musicPaused);
      position: absolute;
      top: 30px;
      right: 30px;
      z-index: 10;
      width: 100px;
      height: 100px;
      &.active {
        background-image: url($music);
        animation: iconSwing 0.5s infinite ease-in-out;
        animation-direction: alternate;
      }
    }
  }
  body[data-webp='support'] {
    #app {
      background-image: url($bgImage + '?imageMogr2/format/webp');
      .music {
        background-image: url($musicPaused + '?imageMogr2/format/webp');
        &.active {
          background-image: url($music + '?imageMogr2/format/webp');
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue